module.exports = __webpack_public_path__ + "static/img/信息披露.6ecf5d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/信息披露.jpg
// module id = 3cGh
// module chunks = 1